import { FC, ReactNode } from 'react';

type CardProps = {
  cardTitle: string;
  children: ReactNode;
  cardButton?: ReactNode;
};

const Card: FC<CardProps> = ({
  cardTitle,
  children,
  cardButton,
}: CardProps) => {
  return (
    <div className="w-full max-w-full rounded-2xl shadow-md bg-white p-4 md:p-6 mb-4 md:m-4">
      <div className="flex justify-between items-center mb-4">
        <h5 className="text-xl font-semibold">{cardTitle}</h5>
        {cardButton || null}
      </div>
      {children}
    </div>
  );
};

export default Card;
